import React from 'react';

import * as styles from './PriceTrackingSlide.module.scss';

export const PriceTrackingSlide = (): React.ReactElement => {
  return (
    <div className={styles.container}>
      <div className={styles.retailThirdImage} />
      <h1 className={`${styles['header-retail-3']} mt-4 mb-2`}>Price tracking informs smart choices</h1>
      <p className={styles['subheader-retail-3']}>
        {`Seeing how products are selling at different price points`}
        <br />
        {`enables you to stay ahead.`}
      </p>
      <p className="text-sm text-inactive mt-2">gfknewron for Retail</p>
    </div>
  );
};
